import { render, staticRenderFns } from "./slot_switch.vue?vue&type=template&id=4d923f62&"
import script from "./slot_switch.vue?vue&type=script&lang=js&"
export * from "./slot_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports